'use strict';

class TabletDemandDisplay {
  constructor() {
    'ngInject';

    this.restrict = 'E';
    this.scope = {
      timeStr: '=',
      maxPower: '=',
      predictedDemand: '=',
      currentPower: '=',
      powerDiff: '=',
      deviceError: '=',
      remainingDiff: '=',
      targetPower: '=',
      limitPower: '=',
      contractPower: '=',
      toggle: '&'
    };
    this.template = require('./tablet-demand-display.html');
  }

  link(scope) {
    scope.getColorClass = () => {
      if (!scope.deviceError.has_error) { return 'tablet-demand-color-normal'; }
      if(this.isError(scope.deviceError)) { return 'tablet-demand-color-contract'; }

      switch (scope.deviceError.demand_level) {
        case 0:
          return 'tablet-demand-color-normal';
        case 1:
          return 'tablet-demand-color-target';
        case 2:
          return 'tablet-demand-color-limit';
        case 3:
          return 'tablet-demand-color-contract';
      }
    };

    scope.statusName = () => {
      switch (scope.deviceError.demand_level) {
        case 0:
          return '正常稼働中';
        case 1:
          return '目標電力超過';
        case 2:
          return '限界電力超過';
        case 3:
          return '契約電力超過';
      }
    };

    scope.getStatus = () => {
      if (!scope.deviceError.has_error) { return 0; }
      if(this.isError(scope.deviceError)) { return 5; }

      return scope.deviceError.demand_level;
    };

    scope.isNotifyTime = () => {
      if (scope.remainingDiff < 300) { return 'tablet-demand-time-flash'; }
    };

    scope.thresholdTitle = () => {
      if (scope.predictedDemand <= scope.targetPower) {
        return '目標電力';
      } else if (scope.predictedDemand <= scope.limitPower) {
        return '限界電力';
      } else {
        return '契約電力';
      }
    };

    scope.thresholdValue = () => {
      if (scope.predictedDemand <= scope.targetPower) {
        return scope.targetPower;
      } else if (scope.predictedDemand <= scope.limitPower) {
        return scope.limitPower;
      } else {
        return scope.contractPower;
      }
    };
  }

  isError(deviceError) {
    return deviceError.cloud_disconnected ||
      deviceError.meter_off ||
      deviceError.meter_fault ||
      deviceError.meter_not_found ||
      deviceError.demand_fault;
  }
}

export default angular.module('leptonApp.tabletDemandDisplay', [])
  .directive('tabletDemandDisplay', [() => new TabletDemandDisplay()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand/detail/tablet-demand-display/tablet-demand-display.directive.js